<template>
  <div style="position: relative" :style="{'padding':'0 10px 0 0'}">
    <div v-if="!enabled" class="mask"></div>
    <div class="gate-link">
      <div class="w-100 d-flex">
        <b-input disabled placeholder="test" :value="domain" label="Domain"  inputClass="base-url"/>
        <div class="link-delim">/</div>
      </div>
      <div class="w-100 d-flex">
        <b-input
            label="Tag 1"
            :value="tag_1"
            @input="tag_1 = $event"
            :show-validate-icons="true"
            :max="50"
            :req="true"
            :error="$v.tag_1.$error || getServerError('tag_1') || getServerError('tags')"
            :v="this.$v.tag_1"/>
        <div class="link-delim">-</div>
      </div>
      <b-input
          label="Tag 2"
          :value="tag_2"
          @input="tag_2 = $event"
          :show-validate-icons="true"
          :max="50"
          :req="true"
          :error="$v.tag_2.$error || getServerError('tag_2') || getServerError('tags')"
          :v="this.$v.tag_2"/>
      <div class="save-button-block d-flex align-items-end" :class="{'disabled': !enabled}">
        <VueCustomTooltip :label="buttonText === 'Saved' ? 'This link has already been saved' : ''"
                          position="is-bottom"
                          abbreviation>
          <b-button
              custom-class="save-btn"
              @click="saveTags"
              variant="normal"
              :disabled="isSaveDisabled"
              type="blue-btn">
            {{ buttonText }}
          </b-button>
        </VueCustomTooltip>
        <LoaderMini class="margin-bottom-1"
                    :showMiniLoader="loading"
                    :successMiniLoader="isSuccess"
                    :failMiniLoader="isError"/>
      </div>
    </div>
    <div class="gate-link-error-block">
      <p v-if="errors['tag_1']">{{errors['tag_1'][0]}}</p>
      <p v-if="errors['tag_2']">{{errors['tag_2'][0]}}</p>
      <p v-if="errors && errors['tags'] && errors['tags'].length">{{errors['tags'][0]}}</p>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import BInput from "@/components/__new_ui_kit/Input/BInput";
import {required} from 'vuelidate/lib/validators'
import LoaderMini from "@/components/LoaderMini/LoaderMini.vue"
import {minMaxLength} from "@/utils/validations/minMaxLength";
import BButton from "@/components/__new_ui_kit/Button/BButton";
import {validateFromServer} from "@/utils/validations/serverValidations";
import {mapActions} from "vuex"
export default Vue.extend({
  data() {
    return {
      isFetching: false,
      validationPromise: null,
      serverErrorText: "",
      tag_1: "",
      tag_2: "",
      loading: false,
      isError: false,
      isSuccess: false,
      errors: {},
      buttonText: 'Save',
      enabled: false
    }
  },
  props: {
    initial_tag_1: {
      type: String,
      default: ''
    },
    initial_tag_2: {
      type: String,
      default: ''
    },
    customUrlId: {
      type: Number
    },
    initialStatus: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BButton,
    BInput,
    LoaderMini
  },
  validations: {
    tag_1: {
      required,
      minMaxLength: minMaxLength(5, 50)
    },
    tag_2: {
      required,
      minMaxLength: minMaxLength(5, 50)
    },
    server: validateFromServer()
  },
  computed: {
    domain() {
      return process.env.VUE_APP_URL
    },
    isSaveDisabled() {
      return this.$v.tag_1.$error || this.$v.tag_2.$error || !this.tag_1 || !this.tag_2 || !!this.serverErrorText || this.buttonText === 'Saved'
    }
  },
  methods: {
    ...mapActions([
        'createCustomLink',
        'updateCustomLink'
    ]),
    getServerError(tag) {
      return (this.errors && this.errors[tag]) ? !!this.errors[tag][0] : false
    },
    saveTags() {
      let data = {
        tag_1: this.tag_1,
        tag_2: this.tag_2
      }
      this.clearServerError('tag_1')
      this.clearServerError('tag_2')
      this.clearServerError('tags')
      this.isSuccess = false
      this.isError = false
      this.loading= true
      if (!this.customUrlId) {
        this.createCustomLink(data)
            .then((response) => {
              this.$emit('set-custom-link-id', response.custom_url_id)
              this.isSuccess = true
              this.buttonText = 'Saved'
            })
            .catch((error) => {
              this.isSuccess = false
              this.isError = true
              this.errors = error.response.data.errors
            })
      } else {
        let update_data = {
          data: data,
          id: this.customUrlId
        }
        this.updateCustomLink(update_data)
            .then((response) => {
              this.$emit('set-custom-link-id', response.custom_url_id)
              this.isSuccess = true
              this.buttonText = 'Saved'
            })
            .catch((error) => {
              this.isSuccess = false
              this.isError = true
              this.errors = error.response.data.errors
            })
      }
    },
    clearServerError(tag) {
      this.serverErrorText = ""
      this.validationPromise = null
      if (!!this.errors) {
        this.errors[tag] = []
      }
    },
    resetLoader() {
      this.loading = false
      this.isSuccess = false
      this.isError = false
    }
  },
  watch: {
    tag_1(v) {
      this.clearServerError('tag_1')
      this.clearServerError('tags')
      this.resetLoader()
      if (v !== this.initial_tag_1) {
        this.buttonText = 'Save'
      }
    },
    tag_2(v) {
      this.clearServerError('tag_2')
      this.clearServerError('tags')
      this.resetLoader()
      if (v !== this.initial_tag_2) {
        this.buttonText = 'Save'
      }
    },
    initialStatus(v) {
      this.enabled = v
    }
  },
  mounted() {
    if (this.$route.params?.id) {
      this.enabled = this.initialStatus
      this.loading = !!(this.initial_tag_1 && this.initial_tag_2)
      this.isSuccess = this.initial_tag_1 && this.initial_tag_2
      this.buttonText = (!!this.initial_tag_1 && !!this.initial_tag_2) ? 'Saved' :'Save'
      this.tag_1 = this.initial_tag_1
      this.tag_2 = this.initial_tag_2
    }
  },
})
</script>
<style lang="scss" scoped>;
.mask {
  width: 100%;
  height: calc(100% + 30px);
  position: absolute;
  top: 0;
  left: 0;
  background: #ffffff10;
  z-index: 1;
  backdrop-filter: blur(4px);
}
.gate-link {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-left: 16px;
  &::v-deep .input-wrap .base-url {
    &:disabled {
      color: $color-main-text;
      background-color: $color-blue-light;
    }
  }
  .link-delim {
    margin-top: 38px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: $color-main-text;
    margin-left: 10px;
  }
  .save-button-block {
    display: flex;
    align-items: flex-end;
    .loader-mini-wrap {
      margin: 0 0 10px 10px
    }
  }
  .save-button-block.disabled {
    // margin: 0 10px 0 0;
  }
  .save-btn {
    margin-top: 28px;
  }
  @media (max-width: 768px) {
    flex-wrap: wrap;
    .input-wrap {
      flex: 100%;
      flex-grow: 0;
    }
    .save-btn {
      flex: 70%;
      flex-grow: 0;
      margin-top: 0;
    }
  }
}
.gate-link-error-block {
  padding: 0 0 0 14px;
  p {
    color: red;
    font-size: 14px
  }
}
@media (max-width: 1630px) and (min-width: 1441px) {
  .gate-link {
    flex-wrap: wrap;
    margin-left: 0;
    .link-delim {
      margin-right: 10px;
    }
    .save-button-block {
      width: 100%;
      abbr {
        width: 100%;
      }
      .blue-btn {
        margin-top: 0;
        width: 100%;
      }
    }
  }
}
@media (max-width: 1440px) and (min-width: 769px) {
  .gate-link {
    flex-wrap: wrap;
    margin-left: 0;
    .link-delim {
      margin-right: 10px;
    }
    .save-button-block {
      width: 100%;
      abbr {
        width: 100%;
      }
      .blue-btn {
        margin-top: 0;
        width: 100%;
      }
    }
  }
}
@media (max-width: 768px) {
  .gate-link {
    flex-direction: column;
    .save-button-block {
      width: 100%;
      abbr {
        width: 100%;
      }
      .blue-btn {
        margin-top: 0;
        width: 100%;
      }
    }
  }
}
</style>